export type AdoszamEredmeny = { ok: true; adoszam: string } | { ok: false };

const TORZS_SULYOK = [9, 7, 3, 1, 9, 7, 3];

/** Magyar adószám (NNNNNNNN-N-NN): a törzsszám ellenőrző jegye (súlyok 9-7-3-1-9-7-3) és az ÁFA-kód (1–5) is számít. */
export function adoszamEllenorzes(bemenet: string): AdoszamEredmeny {
  const s = bemenet.replace(/[\s-]/g, '');
  if (!/^\d{11}$/.test(s)) return { ok: false };
  const osszeg = TORZS_SULYOK.reduce((o, suly, i) => o + suly * Number(s[i]), 0);
  if ((10 - (osszeg % 10)) % 10 !== Number(s[7])) return { ok: false };
  if (!/^[1-5]$/.test(s.charAt(8))) return { ok: false };
  return { ok: true, adoszam: `${s.slice(0, 8)}-${s[8]}-${s.slice(9)}` };
}

/** Cégjegyzékszám (CC-FF-NNNNNN) egységes alakra; hibás bemenetre null. */
export function cegjegyzekszamNormalizalas(bemenet: string): string | null {
  const s = bemenet.replace(/[\s-]/g, '');
  return /^\d{10}$/.test(s) ? `${s.slice(0, 2)}-${s.slice(2, 4)}-${s.slice(4)}` : null;
}

/** Egyéni vállalkozói nyilvántartási szám: 8 számjegy (csak formátumellenőrzés, terv K2). */
export function evSzamEllenorzes(bemenet: string): string | null {
  const s = bemenet.replace(/\s/g, '');
  return /^\d{8}$/.test(s) ? s : null;
}
